import { useSelector } from "react-redux";
import { ReduxState } from "@/redux/type";
import { User, Hash } from "lucide-react";

export default function CustomerGreeting() {
    const customer = useSelector((state: ReduxState) => state.customer);
    if (!customer.cardCode) {
        return null;
    }

    return (
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg shadow-sm border border-blue-100 p-6 mb-4">
            <div className="flex items-center space-x-3">
                <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center">
                        <User className="w-6 h-6 text-white" />
                    </div>
                </div>
                <div className="flex-1 min-w-0">
                    <h1 className="text-2xl font-bold text-gray-800 mb-1">
                        <span>Hello, </span>
                        <span className="text-blue-600 break-words">
                            {customer.name && customer.name.length > 30 
                                ? `${customer.name.substring(0, 30)}...` 
                                : customer.name || 'Valued Customer'
                            }
                        </span>
                    </h1>
                    <div className="flex items-center space-x-2 text-sm text-gray-600">
                        <Hash className="w-4 h-4" />
                        <span className="font-medium">Customer ID: {customer.cardCode}</span>
                    </div>
                </div>
            </div>
            <div className="mt-4 pt-4 border-t border-blue-200">
                <p className="text-sm text-gray-600">
                    Welcome to your account overview. Here you can view your account balance, contact information, and collection volumes.
                </p>
            </div>
        </div>
    );
} 